export default "__VITE_ASSET__71e4fa16__"